<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Allocate Payment To Invoices</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text to="/unallocated-payments">
                    <v-icon left>mdi-arrow-left</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form ref="receiptForm" v-model="valid" :lazy-validation="lazy">
                    <v-row dense class="subtitle-2 text--primary mb-2">
                        <v-col cols="12" md="4">
                            <span>Customer: {{ customer.Name }}</span><br>
                            Deposit Amount: <span style="color: blue"> {{ rct1.Amount | currency }}</span><br>
                            <span>Date paid: {{ rct1.date | date }}</span>
                        </v-col>
                        <!-- end of col 1 -->

                        <!-- start of col 2 -->
                        <v-col cols="12" md="4" class="px-4">

                        </v-col>

                        <!-- start of col 3 -->

                        <v-col cols="12" md="4">
                            Current Balance: <span style="color: red"> {{ currentBalance | currency }}</span><br>
                        </v-col>
                    </v-row>

                    <v-row class="subtitle-2 text--primary">
                        <v-col cols="12">
                            <v-radio-group dense label="Payment Option:" v-model="PaymentOption" row>
                                <v-radio label="Allocate Invoices" value="A"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <v-row style="background-color: #E9EAEC" class="subtitle-2 text--primary"
                        v-if="PaymentOption == 'A'">
                        <v-col cols="12">
                            <v-data-table dense v-model="selected" hide-default-footer :items-per-page="pageItems"
                                :headers="headers" :items="invoices" :search="search" :mobile-breakpoint="zeroValue"
                                item-key="InvoiceId" show-select>
                                <!--  template -->
                                <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal && item.DocTotal | currency
                                    }}</template>
                                <!-- end -->

                                <!-- template -->
                                <template v-slot:item.TotalPaid="{ item }">{{ item.TotalPaid && item.TotalPaid |
                                    currency }}</template>
                                <!-- end -->

                                <!-- template -->
                                <template v-slot:item.Balance="{ item }">{{ item.Balance && item.Balance | currency
                                    }}</template>
                                <!-- end -->

                                <!-- template -->
                                <template v-slot:item.DocDate="{ item }">{{ item.DocDate && item.DocDate | date
                                    }}</template>
                                <!-- end -->
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-2 subtitle-2 text--primary">
                        <v-col cols="12" md="6" v-if="PaymentOption == 'A'">
                            <span class="style-16">Selected Invoices</span>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Invoice No</th>
                                            <th class="text-left">Invoice Amount</th>
                                            <th class="text-left">Invoice Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="item in selected" :key="item.InvoiceId">
                                            <td>{{ item.DocNum }}</td>
                                            <td>
                                                <span class="custom-accent">{{ item.DocTotal | currency }}</span>
                                            </td>
                                            <td>{{ item.DocDate | date }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>

                        <v-col cols="6">
                            <div class="mt-4 mb-2 style-24 float-right">Deposit Amount: {{ rct1.Amount | currency }}
                            </div>
                            <br />
                            <br />
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row class="mt-1">
                        <v-col cols="12">
                            <v-btn color="primary" class="mt-1 float-right" @click="sendData"
                                :loading="loader" :disabled="$store.state.btnLoader">
                                <v-icon left>mdi-content-save</v-icon> Pay Invoices
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    components: {},
    data: () => ({
        totalUnpaidBalance: 0,
        record: {},
        customer: {},
        rct1: {},
        PaymentOption: "A",
        valid: false,
        lazy: false,
        currentBalance: 0,
        selected: [],
        selectedCustomer: null,
        searchCustomers: null,
        paymentModes: [],
        customers: [],
        accounts: [],
        pageItems: 100,
        zeroValue: 0,
        totalDebt: 0,
        search: "",
        invoices: [],
        date: null,
        inputRules: [v => !!v || "Required"],
        headers: [
            { text: "Invoice No", value: "DocNum" },
            { text: "Total", value: "DocTotal" },
            { text: "Amount Paid", value: "TotalPaid" },
            { text: "Balance", value: "Balance" },
            { text: "Date", value: "DocDate" }
        ],
        debtors: []
    }),
    computed: {
        role() {
            return localStorage.getItem("userRole");
        },
        userRole() {
            return localStorage.getItem("userRole");
        }
    },
    watch: {
        "$route.params.id": {
            handler: "fetchRct1Details",
            immediate: true,
        },
    },
    methods: {
        fetchRct1Details(id) {
            const self = this;
            this.$store
                .dispatch("get", `/rct1-details/${id}`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.invoices = res.ResponseData.unclearedInvoices;
                        self.currentBalance = res.ResponseData.currentBalance;
                        self.totalUnpaidBalance = res.ResponseData.totalUnpaidBalance;
                        self.customer = res.ResponseData.customer;
                        self.rct1 = res.ResponseData.rct1;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        sendData() {
            if (!this.$refs.receiptForm.validate()) {
                this.$refs.snackbar.show("Please fill all the fields", "red");
                return;
            }

            if (this.selected.length == 0) {
                this.$refs.snackbar.show("Please select invoices to allocate payment", "red");
                return;
            }

            var invoices = this.selected;
            var totalInvoicesBalance = 0;
            var selectedIds = [];
            for (const invoice of invoices) {
                totalInvoicesBalance += invoice.Balance;
                selectedIds.push(invoice.InvoiceId);
            }

            if (totalInvoicesBalance  < this.rct1.Amount) {
                this.$refs.snackbar.show("invoices balances must be greater or equal to deposit amount", "red");
                return;
            }

            var data = {
                Rct1Id: parseInt(this.rct1.id),
                SelectedIds: selectedIds
            };

            var url = "/allocate-deposit-to-invoices";

            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.$router.push("/unallocated-payments");
                        this.$refs.snackbar.show("invoices paid successfully", "green");
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {

    }
};
</script>